import React from 'react'
//import Image from "next/image";
//import { Link } from "react-router-dom"; //from "next/link";
import { cx } from "../utils/all";
import { urlForImage } from "../lib/sanity/image";
import { parseISO, format } from "date-fns";
import { PhotoIcon } from "@heroicons/react/24/outline";
import CategoryLabel from "./blog/category";
import { blogHref } from "../lib/paths";

export default function PostList({
  post,
  aspect,
  minimal,
  pathPrefix,
  preloadImage,
  fontSize,
  fontWeight
}) {
  //console.log(post)
  const imageProps = post?.mainImage
    ? urlForImage(post.mainImage)
    : null;
  const AuthorimageProps = post?.author?.image
    ? urlForImage(post.author.image)
    : null;
  /* An author document saved without a slug has no /author page to link to.
     Reading .current off it blew up the whole list - one such author blanked
     every post on the blog - so the byline falls back to plain text. */
  const authorSlug = post?.author?.slug?.current;
  return (
    <>
      <div
        className={cx(
          "group cursor-pointer",
          minimal && "grid gap-10 md:grid-cols-2"
        )}>
        <div
          className={cx(
            " overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"
          )}>
          <a
            className={cx(
              "relative block",
              aspect === "landscape"
                ? "aspect-video"
                : aspect === "custom"
                ? "aspect-[5/4]"
                : "aspect-square"
            )}
            href={blogHref(`/post/${pathPrefix ? `${pathPrefix}/` : ""}${
              post.slug.current
            }`)}>
            {imageProps ? (
              <img
                src={imageProps.src}
                {...(post.mainImage.blurDataURL && {
                  placeholder: "blur",
                  blurDataURL: post.mainImage.blurDataURL
                })}
                alt={"laatulakki_"+post.mainImage.alt || "Thumbnail"}
                priority={preloadImage ? "true" : "false"}
                className="object-cover transition-all"
                fill="true"
                sizes="(max-width: 768px) 30vw, 33vw"
              />
            ) : (
              <span className="absolute left-1/2 top-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 text-gray-200">
                <PhotoIcon />
              </span>
            )}
          </a>
        </div>

        <div className={cx(minimal && "flex items-center")}>
          <div>
            <CategoryLabel
              categories={post.categories}
              nomargin={minimal}
            />
            <h2
              className={cx(
                fontSize === "large"
                  ? "text-2xl"
                  : minimal
                  ? "text-3xl"
                  : "text-lg",
                fontWeight === "normal"
                  ? "line-clamp-2 font-medium  tracking-normal text-black"
                  : "font-semibold leading-snug tracking-tight",
                "mt-2    dark:text-white"
              )}>
              <a
                href={blogHref(`/post/${pathPrefix ? `${pathPrefix}/` : ""}${
                  post.slug.current
                }`)}>
                <span
                  className="bg-gradient-to-r to-green-100 bg-[length:0px_10px] bg-left-bottom
      bg-no-repeat
      transition-[background-size]
      duration-500
      hover:bg-[length:100%_3px]
      group-hover:bg-[length:100%_10px]
      dark:from-purple-800 dark:to-purple-900">
                  {post.title}
                </span>
              </a>
            </h2>

            <div className="hidden">
              {post.excerpt && (
                <p className="mt-2 line-clamp-3 text-sm text-gray-500 dark:text-gray-400">
                  <a
                    href={blogHref(`/post/${
                      pathPrefix ? `${pathPrefix}/` : ""
                    }${post.slug.current}`)}
                    legacyBehavior>
                    {post.excerpt}
                  </a>
                </p>
              )}
            </div>

            <div className="mt-3 flex items-center space-x-3 text-gray-500 dark:text-gray-400">
              {(() => {
                const byline = (
                  <div className="flex items-center gap-3">
                    <div className="relative h-5 w-5 flex-shrink-0">
                      {AuthorimageProps && (
                        <img
                          src={AuthorimageProps.src}
                          alt={"laatulakki_ " + (post?.author?.name || "")}
                          className="rounded-full object-cover"
                          fill="true"
                          sizes="20px"
                        />
                      )}
                    </div>
                    <span className="truncate text-sm">
                      {post?.author?.name}
                    </span>
                  </div>
                );
                return authorSlug ? (
                  <a href={blogHref(`/author/${authorSlug}`)} legacybehavior="true">
                    {byline}
                  </a>
                ) : (
                  byline
                );
              })()}
              <span className="text-xs text-gray-300 dark:text-gray-600">
                &bull;
              </span>
              <time
                className="truncate text-sm"
                dateTime={post?.publishedAt || post._createdAt}>
                {format(
                  parseISO(post?.publishedAt || post._createdAt),
                  "MMMM dd, yyyy"
                )}
              </time>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
